import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Approach from "@/components/Approach";
import Credentials from "@/components/Credentials";
import FaqSection from "@/components/FaqSection";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import useSmoothScroll from "@/hooks/useSmoothScroll";

export default function MainSite() {
  useSmoothScroll();
  return (
    <div className="relative">
      <div className="grain-overlay" aria-hidden />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Approach />
        <Credentials />
        <FaqSection />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
